// async function loadSandroModelImages(url, newImages){
//   const newPage = await fetch(url);
//   const newPageText = await newPage.text();

//   const parser = new DOMParser();
//   const newPageDOM = parser.parseFromString(newPageText, 'text/html');

//   const originalImagesContainers = newPageDOM.querySelectorAll('.product__media-list .sandro-product__media');
//   console.log("Anterior contenedor", originalImagesContainers)
//   originalImagesContainers.forEach(container => {
//     console.log(container)
//     container.innerHTML = '';
//     console.log(container)
//   })
  
//   const newNode = originalImagesContainers[0].cloneNode(true);

//   console.log("Nuevo contenedor", originalImagesContainers)
//   console.log('Nuevo nodo:', newNode)

//   // const paginationWrapperNuevo = newPageDOM.querySelector('.sandro-pagination-wrapper');
//   // console.log('Paginacion nueva:', paginationWrapperNuevo)

//   // nodosNuevos.forEach(nodo => {
//   //     collectionGridActual.appendChild(nodo);
//   // });

//   // paginationWrapperActual.innerHTML = paginationWrapperNuevo.innerHTML;

//   // document.dispatchEvent(new CustomEvent("custom:product:updated", {
//   //     detail: {
//   //         collection: collectionGridActual,
//   //         pagination: paginationWrapperActual
//   //     }
//   // }));
// }

function initSandroModelModal() {
  const modelModal = document.querySelector("dialog[data-sandro-model]");
  if (!modelModal) return
  const submitBtn = modelModal.querySelector(".sandro-model-modal__submitBtn");

  const models = modelModal.querySelectorAll('.sandro-model-modal__model[data-sandro-model]');
  let currentProductImages = document.querySelectorAll('.sandro-product__media img');
  let currentProductModalImages = document.querySelectorAll('.sandro-product-media-modal__content img');
  let activeModelImages = [];
  
  models.forEach(model => {
    model.addEventListener("click", (e) => {
      const activeState = model.getAttribute("data-sandro-model-active");
      if (activeState !== "true") {
        const otherModels = [...models].filter(otherModel => otherModel !== model);
        model.setAttribute("data-sandro-model-active", true);
        activeModelImages = model.getAttribute("data-sandro-model-images").split(",");
      
        otherModels.forEach(otherModel => {
          otherModel.removeAttribute("data-sandro-model-active");
        })
      }

    });
  });

  submitBtn.addEventListener("click", (e) => {
    if (currentProductImages === activeModelImages) return

    currentProductModalImages.forEach((img, index) => {
      img.src = `http:${activeModelImages[index]}`;
      img.srcset = "";

    });

    currentProductImages.forEach((img, index) => {
      img.src = `http:${activeModelImages[index]}`;
      img.srcset = "";

    });
    currentProductImages = document.querySelectorAll('.sandro-product__media img');
    currentProductModalImages = document.querySelectorAll('.sandro-product-media-modal__content img');

    modelModal.close();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  function modelModalControls() {
    const showBtn = document.querySelector(".sandro-model-modal__openBtn");
    const closeBtns = modelModal.querySelectorAll(".sandro-model-modal__closeBtn");

    showBtn.addEventListener("click", () => {
      modelModal.showModal();

    });
  
    closeBtns.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        modelModal.close();

      });
    })
  }

  modelModalControls()
}

initSandroModelModal()
